export default "__VITE_ASSET__RJZc3HvY__"